import React, { useContext } from "react";
import _ from "lodash";
import { Container } from "react-bootstrap";
import { Grid } from "@material-ui/core";
import AppBar from "../components/headerNav/HeaderNav";
import { UserContext } from "../context/UserContext";
import { ToolbarContextProvider } from "../context/ToolbarContext";
import { RequestContextProvider } from "../context/RequestContext";
import FormRequest from "../components/request/FormRequest";
import "../styles/form.scss";
import Footer from "../components/footer/Footer";
import CookieConsentBanner from "../components/cookie-consent/CookieConsentBanner";

const NewRequest = () => {
  const { userRole,isUserLoading } = useContext(UserContext);
    
  return _.isEmpty(userRole) ? null : (
    <Container
      fluid
      className="requestContainer">
      <ToolbarContextProvider>
        <Grid container>
          <RequestContextProvider>
            <AppBar />
            <Grid item xs={12}>
              <Container
                fluid
                className="formRequestContainer">
                {!isUserLoading && <FormRequest />}
              </Container>
            </Grid>
            <Footer />
            <CookieConsentBanner />
          </RequestContextProvider>
        </Grid>
      </ToolbarContextProvider>
    </Container>
  );
};

export default NewRequest;
